import { trackGeolocationPopover } from "./geolocation-metrics";

const listenToClose = () => {
  const $modal = $('#geolocationInstructionsModal');
  $modal.off('click.geoInstructions');
  $modal.on('click.geoInstructions', (e) => {
    if (e.target.id === "geolocationInstructionsModal") {
      if (!$modal.is(':visible')) return;
      window.dataLayer = window.dataLayer || [];

      $modal.hide();

      window.dataLayer.push({
        event: "close_element",
        id: "Popover_LocationPermission",
      });
    };
  });
}

const open = () => {
   window.dataLayer = window.dataLayer || []

    $('#geolocationInstructionsModal').css("display", "flex");

    window.dataLayer.push({
      event: "open_element",
      id: "Popover_LocationPermission",
    });

    trackGeolocationPopover();
}

const init = () => {
  listenToClose();
}

const geolocationInstructionsModal = {
  init,
  open,
}

export default geolocationInstructionsModal;
